import React, { useState, useEffect, useCallback } from 'react';
import './Snackbar.css';

const Snackbar = ({ message, type = 'info', duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = useCallback(() => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) {
        onClose();
      }
    }, 300); // Match CSS transition duration
  }, [onClose]);

  useEffect(() => {
    // Only auto-close if duration is greater than 0
    // duration of 0 or null means persistent (no timeout)
    if (duration && duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, handleClose]);

  if (!isVisible) {
    return null;
  }

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className={`snackbar ${type} ${isExiting ? 'exiting' : ''}`}>
      <div className="snackbar-content">
        <div className="snackbar-icon">
          {getIcon()}
        </div>
        <div className="snackbar-message">
          {message}
        </div>
        <button 
          className="snackbar-close"
          onClick={handleClose}
          aria-label="Close notification"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Snackbar;